module.exports = __webpack_public_path__ + "media/video_safras.9598d25a.mp4";